<template>
  <span>
    <b-button
      v-b-modal="modal_name"
      class="ml-2 mb-2"
      size=""
      :variant="
        product_type.exportable ? 'primary' : product_type.waste ? 'danger' : product_type.exportable_bulk ? 'info' : ''
      "
    >
      <span v-if="!loading">{{ product_type.text }}</span>
      <b-spinner small v-if="loading"></b-spinner>
    </b-button>

    <b-modal
      :id="modal_name"
      v-model="modal_status"
      :ok-disabled="remainingKilograms < 0"
      :hide-footer="product_type.exportable_bulk"
      @ok="submit"
      @cancel="cleanForm"
      @close="cleanForm"
      @hide="cleanForm"
      @show="handleShow"
      :title="'Lote ' + lot"
    >
      <div v-if="!loading && product_type.exportable_bulk">
        <create-exportable-bulk
          :loading="loading"
          :container-options="productSet.bulk_containers"
          :lot_id="lot_id"
          :process_id="$route.params.id"
          :product_type="product_type"
          :max_kilograms="remainingKilograms"
          :modal_name="modal_name"
        />
      </div>
      <div v-if="!loading && !product_type.exportable_bulk">
        <!--      Pallet existente -->

        <div class="mb-2" v-if="!isWaste">
          <b-form-checkbox class="mr-2" v-model="auto_number" name="check-button" button :disabled="existing_pallet">
            Correlativo
            <b v-text="auto_number ? 'Activado' : 'Desactivado'"></b>
          </b-form-checkbox>
          <b-form-checkbox v-model="existing_pallet" :disabled="!auto_number" name="check-button" button>
            Completar pallet
          </b-form-checkbox>
        </div>

        <!--      Numero de pallet automatico o manual-->

        <b-form-group
          v-if="!auto_number && !existing_pallet && !isWaste"
          id="example-input-group-2"
          aria-describedby="input-1-live-feedback"
          description="Ingrese número de pallet. Deje en blanco si desea un numero automático."
          label-for="basicNumber"
        >
          <label for="example-input-group-2">
            Número de Pallet (Opcional)
            <a href="#">
              <i class="fa fa-question-circle text-info" v-b-modal.modal-1></i>
            </a>
          </label>

          <b-input-group>
            <b-form-input
              type="text"
              placeholder="123456789"
              :state="$v.contentData.pallet_number.$dirty ? !$v.contentData.pallet_number.$error : null"
              v-model="$v.contentData.pallet_number.$model"
              :readonly="existing_pallet == true"
              v-if="!isWaste"
            >
            </b-form-input>

            <b-input-group-append>
              <b-input-group-text>#</b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

        <!--        Pallet Existente -->
        <template v-if="existing_pallet === true">
          <b-form-group>
            <label for="">
              Pallet existente
              <a href="#"><i class="fa fa-question-circle text-info" v-b-modal.modal-3></i></a>
            </label>
            <search-pallet @selected="existingPalletUpdate($event)"> </search-pallet>
          </b-form-group>
        </template>

        <b-modal size="sm" id="modal-3" title="Tip para completar pallets">
          <p>
            Utilice esta funcion sólo si necesita completar pallets.
            <b>Si usted esta editando y desea que el pallet siga en su lugar, deje esto en blanco. </b>
          </p>
        </b-modal>

        <b-modal size="sm" id="modal-1" title="Tip para numeros específicos">
          <p>
            Ingrese número de pallet. Deje en blanco si desea un numero automático.
            <b>Al usar esta función, evite repetir números.</b> Si quiere usar un pallet existente, utilice la función
            de más abajo.
          </p>
        </b-modal>

        <!--      Aereo o maritimo-->

        <b-form-group v-if="product_type.exportable">
          <label for=""
            >Tipo de envío (Opcional)
            <a href="#"><i class="fa fa-question-circle text-info" v-b-modal.modal-2></i></a>
          </label>
          <b-form-radio v-model="contentData.pallet_type" name="some-radios" value="2">Aéreo</b-form-radio>
          <b-form-radio v-model="contentData.pallet_type" name="some-radios" value="1">Maritimo</b-form-radio>
        </b-form-group>

        <b-modal size="sm" id="modal-2" title="Tip para protocolos de embalaje de pallets">
          <p>
            Si usted tiene protocolos de embalaje de pallets, el sistema reconocerá cuando están completos según la
            cantidad de cajas/bultos que contiene. El protocolo depende de si el pallet es marítimo o aéreo. Para usar
            esta funcionalidad, pregunte a su administrador si ha creado los protocolos y asegúrese de elegir una de
            estas opciones.
          </p>
        </b-modal>

        <b-form-group v-if="product_type.exportable" :description="opMessage">
          <label for="">OP </label>
          <b-form-select :options="opOptions" value-field="id" text-field="id" @change="selectOp"></b-form-select>
        </b-form-group>

        <!--    Especificaciones-->
        <!-- <div v-if="product_type.exportable === true && this.contentData.id === null">
          <b-form-group
            v-for="(type, index) in productSet.spec_type"
            v-bind:label="type.name"
            :key="index"
            label-for="basicSelect"
          >
            <b-form-select id="specSelect" v-model="contentData.specifications[index]">
              <option v-for="spec in type.specs" :key="spec.value" v-bind:value="spec.value">
                {{ spec.text }}
              </option>
            </b-form-select>
          </b-form-group>
        </div> -->

        <!-- Custom Fields -->
        <custom-fields
          v-if="product_type.exportable === true && modal_status"
          :form="contentData.custom_fields"
          :input_group="productSet.export_custom_fields"
        ></custom-fields>

        <!--        Formato/Recipiente-->
        <div v-if="$store.state.user.scope.includes('primero-selecciona-descripcion-y-luego-formato')">
          <b-form-group
            v-if="(!product_type.exportable || !automatic_container) && !isWaste"
            :label="product_type.exportable ? 'Formato' : 'Recipiente'"
            label-for="containerSelect"
          >
            <v-select
              label="text"
              :options="description_options"
              v-model="description"
              @option:selected="handleDescriptionChange"
            >
            </v-select>
          </b-form-group>

          <b-form-group
            v-if="(!product_type.exportable || !automatic_container) && !isWaste"
            :label="product_type.exportable ? 'Peso/Formato' : 'Recipiente'"
            label-for="containerSelect"
          >
            <v-select
              label="text"
              :disabled="!description"
              :required="!product_type.exportable"
              :options="!product_type.exportable ? productSet.bulk_containers : container_options"
              v-model="$v.contentData.container.$model"
            >
            </v-select>
          </b-form-group>
        </div>
        <!-- Lo de arriba es la opcion wishfarms -->

        <div v-else>
          <b-form-group
            v-if="(!product_type.exportable || !automatic_container) && !isWaste"
            :label="product_type.exportable ? 'Formato' : 'Recipiente'"
            label-for="containerSelect"
          >
            <v-select
              label="text"
              :required="!product_type.exportable"
              :options="!product_type.exportable ? productSet.bulk_containers : productSet.exportable_containers"
              v-model="$v.contentData.container.$model"
            >
            </v-select>
          </b-form-group>
        </div>

        <!--      Cantidad-->

        <b-form-group
          id="example-input-group-1"
          aria-describedby="input-1-live-feedback"
          label="Cantidad"
          label-for="basicNumber"
          v-if="!isWaste"
        >
          <b-input-group>
            <b-form-input
              type="text"
              placeholder="Ingrese unidades resultantes"
              :state="$v.contentData.quantity.$dirty ? !$v.contentData.quantity.$error : null"
              v-model="$v.contentData.quantity.$model"
            >
            </b-form-input>

            <b-input-group-append>
              <b-input-group-text>Un</b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

        <!--      Kilos NEtos-->

        <b-form-group label="Kilos netos" label-for="elementsAppend" description="">
          <b-input-group>
            <b-form-input
              type="text"
              v-if="product_type.exportable === false"
              :state="$v.contentData.net_kilograms.$dirty ? !$v.contentData.net_kilograms.$error : null"
              v-model="$v.contentData.net_kilograms.$model"
              :disabled="product_type.exportable === true"
            >
            </b-form-input>
            <b-form-input
              type="text"
              v-if="product_type.exportable"
              :value="calculateExport"
              :disabled="product_type.exportable === true"
            >
            </b-form-input>
            <b-input-group-append>
              <b-input-group-text>Kg</b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

        <!--Sobrepeso-->
        <b-form-group label="Sobrepeso/DH" v-if="product_type.exportable">
          <b-input-group>
            <b-form-input
              placeholder="Ingrese kilos"
              :state="$v.contentData.overweight.$dirty ? !$v.contentData.overweight.$error : null"
              v-model="$v.contentData.overweight.$model"
            >
            </b-form-input>
            <!-- Attach Right button -->
            <b-input-group-append>
              <b-dropdown :text="overweightUnitText" variant="primary" right>
                <b-dropdown-item @click="overweight_unit = true">Kg</b-dropdown-item>
                <b-dropdown-item @click="overweight_unit = false">%</b-dropdown-item>
              </b-dropdown>
            </b-input-group-append>
          </b-input-group>
          <b-form-text id="inputLiveHelp">
            Considere <b>{{ kilogramDif ? kilogramDif : 0 }}</b> % de sobrepeso.
          </b-form-text>
        </b-form-group>

        <!--      Kilos netos totales-->
        <b-form-group label="Kilos netos + sobrepeso" label-for="basicInputDisabled">
          <b-input-group>
            <b-form-input type="text" placeholder="En espera..." :value="calculateNet" disabled> </b-form-input>
            <b-input-group-append>
              <b-input-group-text>Kg</b-input-group-text>
            </b-input-group-append>
          </b-input-group>
          <b-form-text>
            Considere
            <b>{{ remainingKilograms }}</b> Kilos restantes.
          </b-form-text>
        </b-form-group>
      </div>
      <div class="text-center" v-if="loading">
        <b-spinner></b-spinner>
      </div>
    </b-modal>
  </span>
</template>

<script>
import { decimal, integer, minValue, required, requiredIf } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import moment from "moment";
import miniToastr from "mini-toastr";
import SearchPallet from "../reusable/searchPallets";
import vSelect from "vue-select";
import CustomFields from "@/views/recepcion/CustomFields";
import CreateExportableBulk from "./CreateExportableBulk.vue";

export default {
  name: "CreateContent",
  components: {
    CreateExportableBulk,
    CustomFields,
    SearchPallet,
    vSelect
  },
  props: {
    modal_id: {
      type: String,
      default: ""
    },
    lot: {
      type: String,
      default: ""
    },
    net_kilograms_sum_in: {
      type: String,
      default: 0
    },
    net_kilograms_sum_out: {
      type: String,
      default: 0
    },
    lot_id: {
      type: Number,
      default: 0
    },
    product_id: {
      type: Number,
      default: 0
    },
    product_type: {
      type: Object,
      default: {}
    },
    productSet: {
      type: Object,
      default: () => {
        return {
          spec_type: [],
          spec_type_bulk: [],
          bulk_containers: [],
          exportable_containers: [],
          varieties: [],
          export_custom_fields: [],
          product_types: []
        };
      }
    }
  },
  data() {
    return {
      loading: false,
      modal_status: false,
      auto_number: true,
      existing_pallet: false,
      automatic_container: false,
      overweight_unit: false,
      description_options: [],
      container_options: [],
      description: null,
      opOptions: [],
      opMessage: "",
      selectedOp: null,
      maxBoxes: 1000000,
      contentData: {
        id: null,
        lot: null,
        pallet_number: "",
        interplanta: false,
        product: "",
        variety: "",
        condition: "",
        origin: "",
        product_type: "",
        plant: "",
        pallet: null,
        pallet_type: null,
        creation_date: "",
        container: "",
        specifications: [],
        quantity: null,
        gross_kilograms: 0,
        net_kilograms: 0,
        overweight: null,
        origin_kilograms: "",
        other: [],
        client_customer: null,
        custom_fields: {}
      }
    };
  },
  validations: {
    contentData: {
      // product: { required },
      // variety: { required },
      // origin: { required },
      // lot: { required },
      // condition: { required },
      // product_type: { required },
      pallet_number: {
        required: requiredIf(function () {
          return !this.auto_number;
        })
      },
      // plant: { required },
      container: {
        required: requiredIf(function () {
          return (!this.product_type.exportable || !this.automatic_container) && !this.isWaste;
        })
      },
      quantity: {
        required: requiredIf(function () {
          return !this.isWaste;
        }),
        integer,
        minValue: minValue(1)
      },
      overweight: {
        required: requiredIf(function () {
          return this.product_type.exportable;
        }),
        decimal,
        minValue: minValue(0)
      },
      net_kilograms: {
        required,
        decimal
      }
    }
  },
  computed: {
    ...mapState("alfaberriesProcess", {
      container_net_kilograms: (state) => state.container_net_kilograms
    }),
    modal_name() {
      return this.modal_id + "-" + this.product_type.value;
    },
    calculateExport() {
      if (this.container_net_kilograms != undefined) {
        let num = 0;
        if (this.product_type.exportable && this.automatic_container) {
          num = parseFloat(this.container_net_kilograms) * this.contentData.quantity || 0;
        } else {
          num = parseFloat(this.contentData.container.net_weight) * this.contentData.quantity || 0;
        }
        return this.product_type.exportable ? num : this.contentData.net_kilograms;
      }
    },
    overweightUnitText() {
      return this.overweight_unit === true ? "Kg" : "%";
    },
    overweight_kilograms: function () {
      return this.overweight_unit === true
        ? parseFloat(this.contentData.overweight)
        : parseFloat((this.contentData.overweight * this.calculateExport) / 100).toFixed(2);
    },
    kilogramDif() {
      var num = parseFloat(this.overweight_kilograms / this.calculateExport) * 100;
      return num.toFixed(2);
    },
    calculateNet() {
      const num = parseFloat(this.calculateExport) + parseFloat(this.overweight_kilograms);
      return isNaN(num) ? "En espera..." : parseFloat(num).toFixed(2);
    },
    remainingKilograms() {
      let value = this.net_kilograms_sum_in - this.net_kilograms_sum_out - this.calculateNet;
      return parseFloat(value).toFixed(2);
    },
    isWaste() {
      return this.product_type.waste;
    }
  },
  methods: {
    selectOp(evt) {
      if (evt) {
        const selectedOp = this.opOptions.find((op) => op.id === evt);
        if (selectedOp.label) {
          console.log(selectedOp.label);
          this.contentData.custom_fields["etiqueta"] = selectedOp.label;
        }
        if (selectedOp.shipment_type) {
          console.log(selectedOp.shipment_type);
          this.contentData.pallet_type = selectedOp.shipment_type;
        }
        if (selectedOp.caliber) {
          console.log(selectedOp.caliber);
          this.contentData.custom_fields["calibre"] = selectedOp.caliber;
        }
        if (selectedOp.overweight) {
          console.log(selectedOp.overweight);
          this.contentData.overweight = selectedOp.overweight;
        }
        this.selectedOp = selectedOp.id;
        const selectedContainer = this.productSet.exportable_containers.find(
          (container) => container.value === selectedOp.container
        );
        this.contentData.lot = selectedOp.id;
        this.contentData.container = selectedContainer;
        this.maxBoxes = selectedOp.remaining_boxes;
        this.opMessage = `OP para ${selectedOp.plan__subplan} - Embarque: ${
          selectedOp.shipment__boarding_number
        }. Cajas restantes: ${selectedOp.remaining_boxes || 0}`;
      }
    },
    async getOps() {
      this.loading = true;
      try {
        const res = await this.$axios.get(
          `/api/v1/purchase_order/?no_page&status=vigente&fields=id,plan__subplan,remaining_boxes,shipment__boarding_number,container,label,shipment_type,caliber,overweight`
        );
        this.opOptions = res.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    handleShow() {
      this.$v.$reset();
      this.getDescriptions();
      this.getOps();
    },
    async handleDescriptionChange(e) {
      try {
        const response = await this.$axios.get(`/api/v1/container/${e}/by_description/`);
        this.container_options = response.data.exportable_containers;
      } catch (error) {
        console.log(error);
      }
    },
    async getDescriptions() {
      try {
        const response = await this.$axios.get("/api/v1/container/descriptions/");
        this.description_options = response.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    cleanForm() {
      this.automatic_container = false;
      this.overweight_unit = false;
      this.contentData.pallet_number = "";
      this.contentData.id = null;
      this.contentData.lot = null;
      this.contentData.interplanta = false;
      this.contentData.product = "";
      this.contentData.pallet_number = "";
      this.contentData.variety = "";
      this.contentData.condition = "";
      this.contentData.client_customer = "";
      this.contentData.origin = "";
      this.contentData.product_type = "";
      this.contentData.plant = "";
      this.contentData.pallet = "";
      this.contentData.pallet_type = "";
      this.contentData.creation_date = "";
      this.contentData.container = "";
      this.contentData.specifications = [];
      this.contentData.quantity = null;
      this.contentData.gross_kilograms = 0;
      this.contentData.net_kilograms = 0;
      this.contentData.overweight = null;
      this.contentData.origin_kilograms = "";
      this.contentData.other = [];
      this.contentData.custom_fields = {};
    },
    existingPalletUpdate(data) {
      this.contentData.pallet = { id: data.id, text: data.number };
    },
    async submit(evt) {
      const thisV = this;
      thisV.loading = true;
      evt.preventDefault();
      thisV.$v.$touch();
      if (thisV.$v.$invalid) {
        thisV.loading = false;
        thisV.$swal.fire("Faltan datos por ingresar.", "", "error");
        thisV.$emit("validate", false);
        return;
      } else {
        // Create New Content Logic

        if (thisV.contentData.id === null) {
          // Existing Pallet Logic

          if (thisV.existing_pallet === false) {
            thisV.modalShown = false;

            let palletData = {
              tipo: 1,
              number: thisV.contentData.pallet_number,
              auto_number: thisV.auto_number,
              type: thisV.contentData.pallet_type,
              contents: [
                {
                  quantity: Number(thisV.contentData.quantity),
                  net_kilograms: Number(thisV.calculateNet),
                  origin_kilograms: Number(thisV.contentData.origin_kilograms),
                  gross_kilograms: Number(thisV.contentData.gross_kilograms),
                  product_type: thisV.product_type.value,
                  pallet: "",
                  lot: thisV.lot_id,
                  process_id: thisV.$route.params.id,
                  creation_date: moment(thisV.$route.params.start_time).format("YYYY-MM-DD"),
                  overweight_type: thisV.overweight_unit === true ? "0" : "1",
                  container: thisV.contentData.container.value,
                  specifications: thisV.contentData.specifications.filter(Boolean),
                  classification: "",
                  custom_fields: thisV.contentData.custom_fields
                }
              ]
            };

            if (thisV.selectedOp) {
              palletData["op"] = this.selectedOp;
            }

            try {
              const res = await thisV.$axios.post("/api/v1/process/traceability_out/", palletData);
              thisV.$bvModal.hide(thisV.modal_name);
              miniToastr.success("Operación realizada con éxito", "");
              thisV.$store.dispatch("alfaberriesProcess/addRowsOut", res.data);
              thisV.cleanForm();
              thisV.loading = false;
              thisV.$emit("validate", true);
            } catch (error) {
              thisV.loading = false;
              thisV.$bvModal.hide(thisV.modal_name);
              thisV.$toast.error(error.response.data.detail, "");
            }
          }

          // Hasta aca revisado

          if (thisV.existing_pallet === true) {
            const palletData = {
              tipo: 2,
              number: "",
              type: thisV.contentData.pallet_type,
              auto_number: thisV.auto_number,
              contents: [
                {
                  quantity: Number(thisV.contentData.quantity),
                  net_kilograms: Number(thisV.calculateNet),
                  origin_kilograms: Number(thisV.contentData.origin_kilograms),
                  gross_kilograms: Number(thisV.contentData.gross_kilograms),
                  product_type: thisV.product_type.value,
                  pallet: parseInt(thisV.contentData.pallet.id),
                  lot: thisV.lot_id,
                  process_id: thisV.$route.params.id,
                  creation_date: moment(thisV.$route.params.start_time).format("YYYY-MM-DD"),
                  overweight_type: thisV.overweight_unit === true ? "0" : "1",
                  container: thisV.contentData.container.value,
                  specifications: thisV.contentData.specifications.filter(Boolean),
                  classification: "",
                  custom_fields: thisV.contentData.custom_fields
                }
              ]
            };

            if (thisV.selectedOp) {
              palletData["op"] = thisV.selectedOp;
            }

            try {
              const res = await thisV.$axios.post("/api/v1/process/traceability_out/", palletData);
              thisV.$bvModal.hide(thisV.modal_name);
              miniToastr.success("Operación realizada con éxito", "");
              thisV.$store.dispatch("alfaberriesProcess/addRowsOut", res.data);
              thisV.cleanForm();
              thisV.loading = false;
              thisV.$emit("validate", true);
            } catch (error) {
              thisV.loading = false;
              thisV.$bvModal.hide(thisV.modal_name);
              thisV.$toast.error(error.response.data.detail, "");
            }
          }
        }
      }
    }
  }
};
</script>

<style scoped></style>
